module.exports = __webpack_public_path__ + "static/media/Marotte_Tulipier_Endron_MT108-25-Panel.c1a1df32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Tulipier_Endron_MT108-25-Panel.jpg
// module id = 963
// module chunks = 37